<template>
  <table-layout class="user-courses-background rounded rounded-9" title="دوره های من" :showSearch="false">
    <template #buttons></template>
    <template #table>

      <div class="row text-center pt-3">

        <b-table class="col-lg-12" v-bind="tableAttributes" :items="courses" :fields="fields">
          <template #cell(course)="data">
            {{ data.item.title }}
          </template>
          <template #cell(action)="data">

            <m-a class="btn btn-primary rounded-pill px-5 " :href="{name:'SingleCourse',params:{slug:data.item.slug}}">
              <span>مشاهده دوره</span>
            </m-a>
          </template>
        </b-table>

        <pagination class="text-center my-3 mx-auto" :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </template>
  </table-layout>
</template>
<script>
import TableLayout from "../../dashboard/TableLayout";
import Pagination from "../../dashboard/Pagination";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";

export default {
  name: "UserCourse",
  components: {TableLayout, Pagination,},
  data() {
    return {
      courses: [],
      paginationMeta: [],
      tableAttributes,
      fields: [
        {key: "course", label: "دوره"},
        {key: "action", label: ""}
      ],
    }
  },
  methods: {
    changePage(page) {
      const form = {
        page: page,
        user_id: this.$store.getters['User/getUserId']
      }
      this.setUserCourse(form)
    },
    async setUserCourse(form) {
      const res = await this.$store.dispatch("Course/getUserCourses", form);
      const data = res.data.data;
      this.courses = []

      data.data.forEach(product => {
        product.courses.forEach(course => {
          this.courses.push(course)
        })
      })

      this.paginationMeta = data.meta
    }
  },
  async mounted() {
    const form = {
      page: 1,
      user_id: this.$store.getters['User/getUserId']
    }
    await this.setUserCourse(form)

  },
};
</script>
<style scoped>
.user-courses-background{
  background: #f3f3f3;
}
</style>